import { render, staticRenderFns } from "./PacBasicInfoTable.vue?vue&type=template&id=c4544a84&scoped=true"
import script from "./PacBasicInfoTable.vue?vue&type=script&lang=ts"
export * from "./PacBasicInfoTable.vue?vue&type=script&lang=ts"
import style0 from "./PacBasicInfoTable.vue?vue&type=style&index=0&id=c4544a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4544a84",
  null
  
)

export default component.exports